












































































































import Enumerable from "linq";
import Moment from "moment";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { IFreeInputableObject, instanceOfIFreeInputableObject } from "../../objects/IFreeInputableObject";
import { FixedLoading, instanceOfITreeExpandable } from "../../../../system";
import CacheableComponent from "../../../../system/CacheableComponent.vue";
import TabSelector from "../../../../system/selectors/TabSelector.vue";
import {
  instanceOfIEditFixedPhrase,
  UserFixedPhraseSelector,
  CommonDepartmentFixedPhraseSelector,
  DepartmentFixedPhraseSelector,
  FormatFixedPhraseSelector,
  instanceOfISelectedFixedPhraseGettable,
} from "../../../fixedPhrase";
import { FixedPhraseReference, FixedPhraseTextKinds, FixedPhraseTextKindConverter, DocumentEditToolControl } from "../../../../../domain/document";
import { FixedPhraseTextDropManager, IFixedPhraseTextDragParameter } from "../../../../dragging";
import { DomainRegistry } from "../../../../../domain";
import { UserSelectionInformation } from "../../../../../domain/user";

interface IFixedPhraseToolTemplateTab {
  key: string;
  title: string;
  description: string;
  componentName: string;
}

@Component({
  components: {
    TabSelector,
    CacheableComponent,
    userFixedPhraseSelector: UserFixedPhraseSelector,
    commonDepartmentFixedPhraseSelector: CommonDepartmentFixedPhraseSelector,
    departmentFixedPhraseSelector: DepartmentFixedPhraseSelector,
    formatFixedPhraseSelector: FormatFixedPhraseSelector,
    FixedLoading,
  }
})
export default class FixedPhraseTool extends Mixins() {
  @Prop()
  source: IDrawableItemEditable;

  @Prop(String)
  userId: string;

  @Prop(String)
  departmentId: string;

  @Prop(Number)
  formatOriginalId: number;

  @Prop({ default: true })
  isPastable: boolean;

  @Prop()
  editToolControl: DocumentEditToolControl;

  data(): any {
    return {
      selectedTemplateTab: null as IFixedPhraseToolTemplateTab,
      selectedFixedPhrase: null as FixedPhraseReference,
      fixedPhraseTextKind: FixedPhraseTextKinds.Text,
      isFixedPhraseEditing: false,
    };
  }
  selectedTemplateTab: IFixedPhraseToolTemplateTab;
  selectedFixedPhrase: FixedPhraseReference;
  fixedPhraseTextKind: FixedPhraseTextKinds;
  isFixedPhraseEditing: boolean;

  mounted(): void {
    this.setSelectedTemplateTab();
    this.setDefaultSelectedFixedPhraseTextKind();
  }

  private get templateTabs(): IFixedPhraseToolTemplateTab[] {
    return Enumerable.from([
        { key: "user",             title: "個人", description: "個人の定型文を表示します。", componentName: "userFixedPhraseSelector" },
        this.$configuration.behavior.document.editor.contents.fixedPhrase.commonDepartment.isEnable
          ? { key: "commonDepartment", title: "全" + this.$wording.common.departmentAsShort, description: "全" + this.$wording.common.departmentAsShort + "の定型文を表示します。", componentName: "commonDepartmentFixedPhraseSelector" }
          : null,
        { key: "department",       title: "主" + this.$wording.common.departmentAsShort, description: "主" + this.$wording.common.departmentAsShort + "の定型文を表示します。", componentName: "departmentFixedPhraseSelector" },
        { key: "format",           title: "書類", description: "書類の定型文を表示します。", componentName: "formatFixedPhraseSelector" },
      ])
      .where(t => !!t)
      .toArray();
  }

  setSelectedTemplateTab(): void {
    const key = this.$configuration.behavior.document.editor.contents.fixedPhrase.defaultSelectedTab;
    const defaultSelectedTab = Enumerable.from(this.templateTabs).firstOrDefault(t => t.key === key);
    this.selectedTemplateTab = defaultSelectedTab ? defaultSelectedTab : this.templateTabs[0];
  }


  shouldShowTemplateTabContent(key: string): boolean {
    return this.selectedTemplateTab && (this.selectedTemplateTab.key === key);
  }

  private setDefaultSelectedFixedPhraseTextKind(): void {
    if (!this.isPastableSelectorVisible) {
      // 印刷する・しないの切り替えUIが非表示となると変更するすべがないので前回選択値は無視するようにしている
      // 編集タブをデフォルト選択しているとmountedのタイミングでは判定できないのでWatchでも対応している
      return;
    }
    const userSelection = this.$store.getters.userSelection as UserSelectionInformation;
    if (userSelection && userSelection.fixedPhraseDragAndDropMode) {
      this.fixedPhraseTextKind = FixedPhraseTextKindConverter.getFixedPhraseTextKind(userSelection.fixedPhraseDragAndDropMode);
    }
  }

  get isFixedPhrasePastable(): boolean {
    // ボタン自体をD&Dできるので、定型文が選ばれてれば定型文はペースト可とする.
    return this.isPastable
      && (this.selectedFixedPhrase !== null);
  }

  get isAdministratorDepartment(): boolean {
    return this.departmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.departmentId);
  }

  get isCommonItemEditable(): boolean {
    return this.$store.getters.userAuthority.commonItemEditable;
  }

  get isEditFixedPhrase(): boolean {
    return this.shouldShowTemplateTabContent("user") ||
      (this.shouldShowTemplateTabContent("department") && this.isAdministratorDepartment) ||
      (this.shouldShowTemplateTabContent("commonDepartment") && this.isCommonItemEditable) ||
      (this.shouldShowTemplateTabContent("format") && this.$store.getters.userAuthority.formatEditable);
  }

  get isPastableSelectorVisible(): boolean {
    // 相澤病院向けの対応
    // 貼り付けはできてよいが、切り替えUIは非表示としてほしいとのこと
    return this.editToolControl
      ? !!this.editToolControl.isNewTextObjectCreatable
      : true;
  }

  get isExpandButtonVisible(): boolean {
    return !this.$configuration.behavior.fixedPhrase.shouldExpandTreeAutomatically;
  }

  @Watch("isPastableSelectorVisible")
  onIsPastableSelectorVisibleUpdated(newValue: boolean, oldvalue: boolean): void {
    if (!newValue && oldvalue) {
      // 印刷する・しないの切り替えUIが非表示となると変更するすべがないので前回選択値は無視するようにしている
      this.fixedPhraseTextKind = FixedPhraseTextKinds.Text;
    }
  }

  checkedDragPasteKindClass(kind: number): string {
    return this.fixedPhraseTextKind === kind
      ? "checked"
      : "";
  }

  setFixedPhraseTextKind(kind: number): void {
    this.fixedPhraseTextKind = kind;
    this.saveFixedPhraseUserSelection(kind);
  }

  private async saveFixedPhraseUserSelection(kind: FixedPhraseTextKinds): Promise<void> {
    const currentUserSelection = this.$store.getters.userSelection as UserSelectionInformation;
    const editingUserSelection = !!currentUserSelection
      ? currentUserSelection.clone()
      : new UserSelectionInformation();
    editingUserSelection.fixedPhraseDragAndDropMode = FixedPhraseTextKindConverter.getFixedPhraseTextKindText(kind);
    this.$store.commit("setUserSelection", editingUserSelection);
    try {
      const repo = DomainRegistry.user.getUserSelectionRepository();
      repo.saveUserSelection(editingUserSelection);
    } catch (e) {
      this.$logger.warn("ユーザ選択保持情報の保存に失敗しました。");
      this.$logger.warn(e);
    }
  }

  private paste(value: string): void {
    if (this.isSourcePastable(this.source)) {
      this.source.pasteText(value);
    }
  }

  private isSourcePastable(source: any): source is IFreeInputableObject {
    return instanceOfIFreeInputableObject(source) && source.isFreeInputable && source.shouldInputFreeSelfOrAll;
  }

  pasteFixedPhrase(): void {
    this.paste(this.selectedFixedPhrase.text);
  }

  pasteFixedPhraseAndNewLine(): void {
    this.paste(this.selectedFixedPhrase.text + "\n");
  }

  pasteFixedPhraseAndSpace(): void {
    this.paste(this.selectedFixedPhrase.text + " ");
  }

  pasteDate(): void {
    this.paste(Moment().format("YYYY/MM/DD"));
  }

  pasteTime(): void {
    this.paste(Moment().format("HH:mm:ss"));
  }

  private onDragStart(event: DragEvent, text: string): void {
    event.dataTransfer.effectAllowed = "copy";
    event.dataTransfer.setData("text", text);
    const data: IFixedPhraseTextDragParameter = {
      kind: this.fixedPhraseTextKind,
      text,
    };
    const manager = new FixedPhraseTextDropManager();
    manager.parameter = data;
  }

  onDragStartFixedPhrase(event: DragEvent): void {
    this.onDragStart(event, this.selectedFixedPhrase.text);
  }

  onDragStartFixedPhraseAndNewLine(event: DragEvent): void {
    this.onDragStart(event, this.selectedFixedPhrase.text + "\n");
  }

  onDragStartFixedPhraseAndSpace(event: DragEvent): void {
    this.onDragStart(event, this.selectedFixedPhrase.text + " ");
  }

  onDragStartDate(event: DragEvent): void {
    this.onDragStart(event, Moment().format("YYYY/MM/DD"));
  }
  
  onDragStartTime(event: DragEvent): void {
    this.onDragStart(event, Moment().format("HH:mm:ss"));
  }

  expandTree(): void {
    const tree = this.$refs[this.selectedTemplateTab.componentName];
    if (instanceOfITreeExpandable(tree)) {
      tree.expandTree();
    }
  }

  editFixedPhrase(): void {
    const tree = this.$refs[this.selectedTemplateTab.componentName];
    if (instanceOfIEditFixedPhrase(tree) && !this.isFixedPhraseEditing) {
      this.isFixedPhraseEditing = true;
      tree.editFixedPhrase()
      .finally(() => {
        this.isFixedPhraseEditing = false;
      });
    }
  }

  @Watch("selectedTemplateTab")
  onSelectedTemplateTabUpdated(newValue: IFixedPhraseToolTemplateTab, oldValue: IFixedPhraseToolTemplateTab): void {
    if (!newValue || !oldValue) { return; }
    // 各タブ内で定型文を選択した状態のままタブを切り替えたとき、
    // FixedPhraseToolのselectedFixedPhraseと表示中のタブで選択されている定型文とが一致しなくなってしまうので強制的に整合させている
    const tree = this.$refs[this.selectedTemplateTab.componentName];
    this.selectedFixedPhrase = instanceOfISelectedFixedPhraseGettable(tree)
      ? tree.getSelectedFixedPhrase()
      : null;
  }
}
